import { graphql } from "../gql/index.ts";

export const BulkClassRoomCreationRequestFragment = graphql(`
  fragment BulkClassRoomCreationRequest on BulkClassRoomCreationRequestGraphqlDto {
    id
    createdAt
    updatedAt
    status
    totalClassRoomsToCreate
    teacher {
      id
      givenName
      familyName
    }
    user {
      id
      givenName
      familyName
      authId
    }
  }
`);
